import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-times",
  "use": "foquz-icon-times-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" id=\"foquz-icon-times\"><path d=\"M.95 10.85a1 1 0 010-1.415L9.435.95a1 1 0 111.414 1.414l-8.485 8.485a1 1 0 01-1.414 0z\" fill=\"currentColor\" /><path d=\"M10.85 10.85a1 1 0 01-1.415 0L.95 2.363A1 1 0 112.364.95l8.485 8.485a1 1 0 010 1.414z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol